module.exports = __webpack_public_path__ + "images/dif-in-means-02-mobile.webp";